import fetch from 'fetch';
import Service from '@ember/service';
import ENV from 'bullitt-time-gochips/config/environment';

export default class AjaxService extends Service 
{
	host =  ENV.eventBackendProtocol+"://"+ENV.eventBackendHost+":"+ENV.eventBackendPort+(ENV.eventBackendNamespace ? "/"+ENV.eventBackendNamespace : "");
	
	request(url)
	{
		return fetch(this.host+url).then(function(response)
		{
			return response.json();
		});
	};
}